var path = '/components/directives/customfield/boolean.tpl.html';
var html = "<label>\n    {{::field.definition.name}}\n    <i class=\"fal fa-info-circle\" ng-if=\"field.definition.tooltip\">\n        <span data-tooltip=\"{{::field.definition.tooltip}}\"></span>\n    </i>\n</label>\n<al-switch config=\"{name:name,label:field.definition.name,disabled:!!field.definition.disabled}\" model=\"field.ngModel\" on-change=\"field.definition.onChange\"></al-switch>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/boolean.tpl.html
// module id = 1979
// module chunks = 1